export default __webpack_public_path__ + "static/media/history.3c98fbdb.jpg";